import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { ExternalBetslipActions } from 'packages/sports/common/betslip/core/external-betslip-actions';
import { BetBuilderPickId } from 'packages/sports/common/betslip/core/picks/pick-id';

import {
    AddToBetslipPayload,
    BetBuilderPickIdType,
    CreatePickPayload,
    IBetBuilderBetSlipService,
    RemoveFromBetslipPayload,
} from './bet-builder-betslip-service.model';

@Injectable({ providedIn: 'root' })
export class BetBuilderBetslipService implements IBetBuilderBetSlipService {
    constructor(private store: Store) {}

    addToBetslip({ event, betBuilderMarket, tracking }: AddToBetslipPayload): void {
        if (!betBuilderMarket) {
            return;
        }

        const { id, startDate, name, live, groupId, league, region, offerSource, betBuilderTradingV2FixtureId } = event;

        const eventData = {
            event: {
                id,
                date: startDate,
                name,
                isLive: live,
                groupId,
            },
            league: {
                id: league.id,
                name: league.name,
                parentLeagueId: league.parentLeagueId,
            },
            region: {
                id: region.id,
                name: region.name,
            },
            offerSource,
            betBuilderTradingV2FixtureId,
        };

        const longId = betBuilderMarket.option.longId;
        const pickId = new BetBuilderPickId(
            event.id,
            betBuilderTradingV2FixtureId || id,
            betBuilderMarket.id,
            betBuilderMarket.option.id,
            betBuilderMarket.option.optionPrice.id,
        );
        if (longId) {
            this.store.dispatch(
                ExternalBetslipActions.addEntainUiBetBuilderPick({
                    pickId,
                    tracking,
                    eventData,
                    betBuilderOptionMarket: betBuilderMarket,
                    eventModel: event,
                    longId,
                }),
            );

            return;
        }

        this.store.dispatch(
            ExternalBetslipActions.addBetBuilderPick({
                pickId,
                tracking,
                eventData,
                additionalInfo: {
                    sportcastId: event.sportcastId,
                    betgeniusId: Number(event.getBetBuilderConsumerFixtureId()),
                    longIds: betBuilderMarket.longIds,
                    useV2Key: Boolean(event.betBuilderTradingV2FixtureId),
                },
            }),
        );
    }

    removeFromBetslip({ eventId, longId, pickIds }: RemoveFromBetslipPayload): void {
        const pickId = pickIds[0] as BetBuilderPickId;

        if (longId) {
            this.store.dispatch(
                ExternalBetslipActions.removeEntainUiBetBuilderPick({
                    pickId,
                    longId,
                    eventId,
                }),
            );
            return;
        }

        this.store.dispatch(ExternalBetslipActions.removePick({ pickId }));
    }

    createPicks({ eventId, betBuilderMarket, betBuilderFixtureId }: CreatePickPayload): BetBuilderPickIdType[] {
        if (!betBuilderMarket || !eventId) {
            return [];
        }
        return [
            new BetBuilderPickId(
                eventId,
                betBuilderFixtureId || eventId,
                betBuilderMarket.id,
                betBuilderMarket.option.id,
                betBuilderMarket.option.optionPrice.id,
            ),
        ] as BetBuilderPickId[];
    }
}
